// src/services/surveyService.js

import { ENDPOINTS } from "../config";

const surveyService = {

  getAll: async () => {
    const token = localStorage.getItem('authToken');
    
    if (!token) {
      throw new Error('No authentication token found. Please log in.');
    }

    const response = await fetch(ENDPOINTS.SURVEYS, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Unauthorized: Identity not verified (401).');
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  create: async (surveyData) => {
    const token = localStorage.getItem('authToken');
    
    if (!token) throw new Error('No authentication token found.');

    const response = await fetch(ENDPOINTS.SURVEYS, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(surveyData)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({})); 
      const errorMessage = errorData.title || errorData.message || `Creation failed: ${response.statusText}`;
      throw new Error(errorMessage);
    }

    return await response.json();
  },

  getByToken: async (token) => {
    const response = await fetch(ENDPOINTS.SURVEY_PUBLIC(token), {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Survey not found or expired.');
    }

    return await response.json();
  },

  submitResponse: async (token, formData) => {
    const response = await fetch(ENDPOINTS.SURVEY_RESPONSES(token), {
      method: 'POST',
      body: formData // Don't set Content-Type for multipart/form-data
    });

    if (!response.ok) {
      throw new Error('Submission failed.');
    }

    return await response.json();
  },

  getResponsesBySurveyId: async (surveyId) => {
    const token = localStorage.getItem('authToken');
    
    if (!token) {
      throw new Error('No authentication token found. Please log in.');
    }

    const response = await fetch(ENDPOINTS.SURVEY_RESPONSES_BY_ID(surveyId), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Unauthorized: Identity not verified (401).');
      }
      if (response.status === 404) {
        throw new Error('Survey not found.');
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  }
};

export default surveyService;